import React from 'react';
import { Icon, Link } from '@hz-design-system/web-ui';
import Classes from '../ProfileSidebar.scss';

const EmailInfo = ({ email }: { email: string }) => (
  <li className={Classes.infoWrap}>
    <Icon name="email" className={Classes['infoWrap-icon']} />
    <Link href={`mailto:${email}`}>{email}</Link>
  </li>
);

export default EmailInfo;
